export const Config = {
  ApiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  Token: process.env.REACT_APP_API_TOKEN,
}
